const ORDER_ID_KEY = "orderTracking"

export const getOrderRecord = () => {
    let orderHistory = getItem(ORDER_ID_KEY)
    if (orderHistory && orderHistory.length > 0) {
        for (let key in orderHistory) {
            if (orderHistory[key].expire < new Date().getTime()) {
                orderHistory.splice(key, 1)
            }
        }
    }else{
        orderHistory = []
    }
    return orderHistory
};

export const removeOrderRecord = (orderId) => {
    let orderHistory = getOrderRecord();
    for (let key in orderHistory) {
        if (orderHistory[key].orderId == orderId) {
            orderHistory.splice(key, 1)
        }
    }
    return setItem(ORDER_ID_KEY, orderHistory)
};

export const addOrderRecord = (orderId) => {
    let orderHistory = getOrderRecord();
    let expire = new Date().getTime() + 1000 * 60 * 60 * 3; //3hr
    orderHistory.push({ orderId: orderId, expire: expire })
    return setItem(ORDER_ID_KEY, orderHistory)
};


export const setItem = (name, value, expire = null) => {
    return window.localStorage.setItem(name, JSON.stringify({ value: value, expire: expire }));
};

export const getItem = (name) => {
    var value = false
    var cache = JSON.parse(window.localStorage.getItem(name))
    if (cache) {
        if (cache.expire && cache.expire <= new Date().getTime()) {
            window.localStorage.clear(name)
        } else {
            value = cache.value
        }
    } else {
        value = null
    }
    return value
};

export default { setItem, getItem, getOrderRecord, addOrderRecord, removeOrderRecord };
